// import { generatePermissionsAll } from 'helpers/verifyPermission';

export const menuPermissions = [
    { path: "/admin", icon: "dashboard", label: "Dashboard", permissions: [] },
    { path: "/admin/cidades", icon: "city", label: "Cidades", permissions: [] },
    { path: "/admin/estados", icon: "state", label: "Estados", permissions: [] },
    { path: "/admin/paises", icon: "country", label: "Países", permissions: [] },
    { path: "/admin/usuarios", icon: "users", label: "Usuários", permissions: [] },
    { path: "/admin/papeis", icon: "permission", label: "Papéis", permissions: [] },
    { path: "/admin/categorias", icon: "permission", label: "Categorias", permissions: [] },
]